export const convertImageToBase64 = (imageUrl: string): Promise<string> => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    return new Promise(resolve => {
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      // Fall back to the original URL on load errors so callers can still
      // display the image even when the canvas pipeline can't run (e.g. CORS).
      img.onerror = () => resolve(imageUrl);
      img.crossOrigin = 'anonymous';
      img.src = imageUrl;
    });
  } catch (error) {
    console.error('Failed to convert image to base64:', error);
    return Promise.resolve(imageUrl);
  }
};
